import { FC } from "react";
import { Box, Typography, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

interface YearSelectProps {
  year: number;
  onPrev: () => void;
  onNext: () => void;
  disabled?: boolean;
}

export const YearSelect: FC<YearSelectProps> = ({ year, onNext, onPrev, disabled }) => {
  const classes = useStyles();

  return (
    <Box data-testid="testYearSelect" className={classes.dateBox}>
      <IconButton
        data-testid="testYearSelectButton"
        color="primary"
        onClick={onPrev}
        className={classes.iconButton}
      >
        <NavigateBeforeIcon />
      </IconButton>
      <Typography className={classes.date} variant="body2">
        Year {year}
      </Typography>
      <IconButton
        data-testid="testYearSelectButtonTwo"
        color="primary"
        onClick={onNext}
        className={classes.iconButton}
        disabled={disabled}
      >
        <NavigateNextIcon />
      </IconButton>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  date: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    display: "flex",
    flexDirection: "row",
  },
  dateBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "0 10px",
  },
  iconButton: {
    padding: "0",
    margin: "0 10px",
  },
}));
